import { render, staticRenderFns } from "./ProOptionWrapper.vue?vue&type=template&id=d4146cb6"
import script from "./ProOptionWrapper.vue?vue&type=script&lang=js"
export * from "./ProOptionWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4146cb6')) {
      api.createRecord('d4146cb6', component.options)
    } else {
      api.reload('d4146cb6', component.options)
    }
    module.hot.accept("./ProOptionWrapper.vue?vue&type=template&id=d4146cb6", function () {
      api.rerender('d4146cb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pro-option-wrapper/ProOptionWrapper.vue"
export default component.exports